// ============================================
// REPOSE HOTELS WEBSITE CONTENT CONFIGURATION
// ============================================
// Edit this file to update website content easily
// After making changes, save the file and refresh your browser

export const siteConfig = {
  // ============================================
  // CONTACT INFORMATION
  // ============================================
  contact: {
    phone: '0448066548',
    phoneDisplay: '0448 066 548',
    email: 'info@reposehotels.com.au',
    location: {
      city: 'Melbourne',
      state: 'Victoria',
      country: 'Australia'
    },
    officeHours: {
      weekdays: '9:00 AM - 5:00 PM',
      weekend: 'Closed'
    }
  },

  // ============================================
  // COMPANY INFORMATION
  // ============================================
  company: {
    name: 'Repose Hotels Pty Ltd',
    tagline: 'Strategic Hotel Asset Partners',
    founded: '2016',
    description: 'Founded in 2016 by Scott Orchard and Anand Sangwan, Repose Hotels Pty Ltd has established itself as a distinguished player in the hospitality realm with experience successfully owning and managing hotels and a management rights business.',
    vision: 'Set new standards in hospitality by seamlessly blending opulence with warmth, ensuring that every guest feels cherished and valued from the moment they step through our doors.',
    commitment: 'Dedication to unparalleled service, attention to detail, and passion for hospitality are the cornerstones of our identity. We strive to create cherished memories for our guests, leaving them with a longing to return and relive the magic of their stay with us.'
  },

  // ============================================
  // KEY STATISTICS
  // ============================================
  stats: {
    experience: '40+',
    experienceLabel: 'Years Combined Experience',
    awards: '3×',
    awardsLabel: 'Franchise Award Nominations',
    ranking: '#1',
    rankingLabel: 'Market Rankings Achieved',
    rating: '5★',
    ratingLabel: 'TripAdvisor Ratings',
    rentalRecord: '$1.5M+',
    rentalRecordLabel: 'Annual Rent (Unblemished Record)',
    portfolioValue: '$30M',
    portfolioValueLabel: 'Corporate Portfolio Managed'
  },

  // ============================================
  // CORE PRINCIPLES
  // ============================================
  principles: [
    {
      title: '5-Star Service',
      description: 'Operational excellence is non-negotiable'
    },
    {
      title: 'Value for Money',
      description: 'Strong cost control without compromising guest experience'
    },
    {
      title: 'Presence',
      description: 'Active leadership involvement—not remote oversight'
    },
    {
      title: 'Flexibility',
      description: 'Adaptability to market cycles and demand shifts'
    },
    {
      title: 'Consistency',
      description: 'Reliable performance standards across all assets'
    }
  ],

  // ============================================
  // LEADERSHIP TEAM
  // ============================================
  team: [
    {
      name: 'Scott Orchard',
      title: 'Director – Corporate Development & Strategic Partnerships',
      description: 'Scott is a dynamic and accomplished professional with over two decades of experience in the travel and hospitality industry. His role as National Business Manager at BCD Travel saw him managing a client portfolio worth $30 million, negotiating supplier agreements, and implementing cost-effective travel management programs for high-profile clients.',
      expertise: [
        'Corporate Account Acquisition',
        'Key Account Management',
        'Supplier Contract Negotiation',
        'Revenue Growth Strategy',
        'Pre-Opening Sales Campaigns'
      ],
      image: 'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/712cr8a6_Snip20260313_2.png'
    },
    {
      name: 'Anand Sangwan',
      title: 'Managing Director – Operations & Financial Strategy',
      description: 'Anand is a seasoned hospitality professional with extensive experience leading high-performing teams and managing complex operations. Qualified from Wellington Institute of Technology and Institute of Hotel Management, New Delhi. Known for his financial acumen including deep understanding of P&Ls, balance sheets, and managerial accounting.',
      expertise: [
        'Financial Modelling & Forecasting',
        'Budget Development & Capital Planning',
        'Operational Efficiency',
        'Franchise Compliance',
        'Quality Control & Pre-Opening Setup'
      ],
      image: 'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/712cr8a6_Snip20260313_2.png'
    }
  ],

  // ============================================
  // CASE STUDIES
  // ============================================
  caseStudies: [
    {
      title: 'Comfort Inn & Suites Latrobe',
      location: 'Latrobe, Victoria',
      year: '2016-2018',
      role: 'Owner Operators',
      image: 'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/u77qzgjk_comfort%20inn.jpeg',
      additionalImages: [
        'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/uuemm98p_image.png',
        'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/uhpkw56h_image.png'
      ],
      challenge: 'Acquired property requiring strategic renovations and disciplined revenue management practices in partnership with Choice Hotels corporate office.',
      strategy: [
        'Strategic renovations and property upgrades',
        'Implemented disciplined revenue management',
        'Partnership with Choice Hotels corporate',
        'Guest satisfaction improvement program'
      ],
      results: [
        { metric: '50% Growth', value: 'Year-on-year occupancy increase' },
        { metric: 'Strong Turnaround', value: 'Guest satisfaction improvement' },
        { metric: 'Successful Sale', value: '2018 following performance uplift' },
        { metric: 'Profitability', value: 'Substantial increase achieved' }
      ],
      impact: '50% year-on-year occupancy growth, strong turnaround in guest satisfaction and property profitability. Successful sale in 2018 following substantial uplift in performance.'
    },
    {
      title: 'Quest Maribyrnong',
      location: 'Melbourne, Victoria',
      year: '2018-2023',
      role: 'Development & Market Leader',
      image: 'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/cff1xofl_image.png',
      challenge: 'Greenfield franchise development requiring complete hotel setup from ground up—people, systems, sales, and brand execution. Pre-opening strategy began 6 months prior.',
      strategy: [
        'Six-month pre-opening sales campaign by Scott',
        'Built early brand visibility and corporate relationships',
        'Two-month recruitment and training program',
        'Two-week defect and quality-control program by Anand',
        'Full operational setup to 4.5-star standards'
      ],
      results: [
        { metric: '5-Star Rating', value: 'TripAdvisor (sustained #1 ranking)' },
        { metric: '3× Nominations', value: 'Quest Franchise of the Year' },
        { metric: '97%+ Scores', value: 'Quarterly franchisor valuations' },
        { metric: 'Strong Returns', value: 'Successful sale in 2023' }
      ],
      impact: 'Achieved 5-star TripAdvisor rating and sustained #1 ranking in local market. Nominated three times for Quest Franchise of the Year. Consistently exceeded KPIs across occupancy, ADR, RevPAR, guest satisfaction, and brand audits. Delivered strong financial performance leading to successful sale in 2023.'
    },
    {
      title: 'Docklands Private Collection',
      location: 'Docklands, Melbourne',
      year: '2023-Present',
      role: 'Management Rights Acquisition',
      image: 'https://customer-assets.emergentagent.com/job_asset-growth-6/artifacts/rrkwiygf_image.png',
      challenge: 'Acquired and assumed management rights for 75 apartments in one of Melbourne\'s most competitive accommodation precincts.',
      strategy: [
        'Transformed family-run business into professional operation',
        'Implemented modern processes and revenue systems',
        'Enhanced service standards',
        'Strengthened owner and corporate client engagement'
      ],
      results: [
        { metric: 'Occupancy Growth', value: 'Rapid improvements achieved' },
        { metric: 'ADR Increase', value: 'Enhanced pricing strategies' },
        { metric: 'Owner Returns', value: 'Improved investment performance' },
        { metric: 'Professional Systems', value: 'Modern operational framework' }
      ],
      impact: 'Rapid improvements in occupancy, ADR, and owner returns through transformation from family-run business to fully professional, system-driven operation with modern processes and service standards.'
    }
  ],

  // ============================================
  // BUSINESS ACQUISITION ASSISTANCE
  // ============================================
  acquisitionAssistance: {
    title: 'Business Acquisition & Growth Advisory',
    description: 'Comprehensive support for aspiring and existing hotel owners',
    services: [
      {
        title: 'First-Time Buyer Guidance',
        description: 'Assisted numerous people acquire their first hotel, motel, serviced apartment, and management rights business',
        features: [
          'Complete business evaluation and due diligence',
          'Negotiation strategy and support',
          'Financial analysis and risk assessment',
          'Franchise selection guidance',
          'Settlement and transition planning'
        ]
      },
      {
        title: 'Financial Planning & Projections',
        description: 'Creating comprehensive 5-year budget and cashflow projections to ensure business viability',
        features: [
          '5-year financial forecasting',
          'Cash flow projection modeling',
          'Revenue and expense planning',
          'Capital expenditure scheduling',
          'Break-even and ROI analysis',
          'Sensitivity and scenario planning'
        ]
      },
      {
        title: 'Sales Planning & Implementation',
        description: 'Implementing successful sales plans with proven strategies to drive revenue growth',
        features: [
          'Corporate account development strategy',
          'Local market penetration plans',
          'Direct booking optimization',
          'Distribution channel management',
          'Pricing and yield strategy',
          'Marketing and promotional planning'
        ]
      },
      {
        title: 'Operational Excellence Programs',
        description: 'Daily operational checklists and systems to increase NOP and business value',
        features: [
          'Daily operational checklists and SOPs',
          'Cost control and efficiency programs',
          'Quality assurance systems',
          'Staff training and development',
          'Guest satisfaction improvement',
          'NOP (Net Operating Profit) optimization',
          'Business valuation enhancement for successful exit'
        ]
      }
    ],
    results: {
      title: 'Proven Success in Business Growth',
      achievements: [
        'Multiple successful first-time acquisitions',
        'Improved NOP across managed properties',
        'Enhanced business valuations for exit',
        'Successful business sales with maximized returns',
        'Sustainable operational systems implemented'
      ]
    }
  },

  // ============================================
  // FINANCIAL STRENGTH
  // ============================================
  financialStrength: {
    title: 'Financial Strength & Landlord Reliability',
    highlights: [
      'Unblemished rental payment history across multiple leases',
      'Annual rent exceeding $1.5M at Quest Maribyrnong',
      'Never missed or delayed rental payments',
      'Maintained strong relationships with both single-ownership and strata landlords',
      'Demonstrated financial stability during COVID-19'
    ]
  },

  // ============================================
  // COMMUNITY COMMITMENT
  // ============================================
  community: {
    title: 'Community Commitment & Social Impact',
    description: 'Repose Hotels operates on the principle that hotels must contribute meaningfully to the communities they serve.',
    initiatives: [
      {
        name: 'Western Health Foundation Support',
        description: 'Regular contributors to fundraising efforts for the new Footscray Hospital development'
      },
      {
        name: 'Local Schools & Kindergartens',
        description: 'Ongoing grassroots involvement through donation of gift vouchers for fetes, raffles, and community events'
      },
      {
        name: 'Local Talent Sponsorship',
        description: 'Supported a national-level badminton player, assisting them to pursue competitive aspirations'
      }
    ]
  },

  // ============================================
  // PARTNERSHIP WITH CHOICE HOTELS
  // ============================================
  partnership: {
    name: 'Choice Hotels International',
    description: 'Partnership unites Choice Hotels\' global sales and distribution reach with Repose team\'s proven operational expertise.',
    benefits: [
      'World\'s third-largest hotel group',
      '7,500+ properties worldwide',
      '~70m loyalty program members',
      '150+ properties in Australia',
      'Ascend Collection brand positioning',
      'Dedicated Revenue Management',
      'Group procurement power',
      '10,000+ products at discounted rates'
    ]
  },

  // ============================================
  // ADDITIONAL SERVICES
  // ============================================
  additionalServices: [
    {
      title: 'Training & Development',
      description: 'Comprehensive operational and sales training programs designed to elevate your team\'s performance and service excellence.',
      fullDescription: 'We provide your teams with world-class operational training and sales training tailored to the hospitality industry. Our programs can be delivered one-on-one or to entire teams, whether you are an individual hotel or a multi-property hotel chain.',
      features: [
        'Operational Excellence Training - Front desk, housekeeping, F&B service standards',
        'Sales & Revenue Training - Corporate account acquisition, negotiation skills, upselling techniques',
        'Leadership Development - Management training for supervisors and department heads',
        'Brand Standards Compliance - Franchise-specific training and quality assurance',
        'Guest Service Excellence - Service recovery, complaint handling, exceeding expectations',
        'New Property Pre-Opening Training - Complete team setup and onboarding programs',
        'Customized Training Programs - Tailored to your property\'s specific needs and challenges',
        'Flexible Delivery - On-site, online, or hybrid training formats'
      ],
      benefits: [
        'Improved guest satisfaction scores',
        'Enhanced operational efficiency',
        'Increased revenue through better sales techniques',
        'Reduced staff turnover through professional development',
        'Consistent service delivery across all touchpoints'
      ]
    },
    {
      title: 'IT Solutions & Technology Integration',
      description: 'Strategic partnerships with leading hospitality technology providers to optimize your operations and enhance guest experiences.',
      fullDescription: 'We partner with various specialized IT firms to provide comprehensive technology solutions that drive efficiency, reduce costs, and improve guest satisfaction. Our network of trusted technology partners ensures you have access to best-in-class hospitality systems.',
      features: [
        'Automated Revenue Management Tools - Dynamic pricing, demand forecasting, and yield optimization systems',
        'Channel Manager Integration - Real-time inventory distribution across all OTAs and booking channels',
        'Property Management Systems (PMS) - Modern cloud-based solutions for seamless operations',
        'Smart Lock Systems - Keyless entry, mobile check-in, and enhanced security solutions',
        'Communication Infrastructure - VoIP phone systems, high-speed internet, and guest WiFi solutions',
        'After-Hours Management - 24/7 remote support and automated guest communication systems',
        'Booking Engine Optimization - Direct booking platforms with commission-free reservations',
        'Guest Experience Technology - Digital check-in/out, in-room tablets, and mobile concierge services',
        'Back-Office Automation - Time & attendance, rostering, and task management systems',
        'Data Analytics & Reporting - Real-time dashboards and business intelligence tools'
      ],
      benefits: [
        'Reduced operational costs through automation',
        'Increased direct bookings and reduced OTA commissions',
        'Enhanced guest satisfaction through modern technology',
        '24/7 operational support and monitoring',
        'Data-driven decision making with real-time insights'
      ]
    },
    {
      title: 'Accounting & Financial Management',
      description: 'Specialized hotel accounting and bookkeeping services providing complete financial transparency and strategic insights for hospitality investments.',
      fullDescription: 'Our comprehensive accounting and bookkeeping services are specifically designed for the unique needs of hotel operations. We provide detailed financial management that goes beyond basic bookkeeping to deliver strategic insights for better decision-making.',
      features: [
        'Hotel-Specific Chart of Accounts - USALI (Uniform System of Accounts for the Lodging Industry) compliant accounting',
        'Daily Revenue Reconciliation - Front desk, F&B, and ancillary revenue tracking and verification',
        'Department-Level P&L Reporting - Rooms, F&B, events, and other revenue center performance analysis',
        'Trust Accounting - Guest deposits, advance bookings, and security deposit management',
        'Accounts Payable & Receivable - Vendor management, invoice processing, and corporate billing',
        'Payroll Administration - Staff wages, superannuation, leave accruals, and tax compliance',
        'Month-End & Year-End Close - Complete financial reporting packages and audit preparation',
        'Budget Preparation & Variance Analysis - Annual budgets, forecasts, and performance comparisons',
        'Capital Expenditure Tracking - FF&E reserve management and major project accounting',
        'Revenue Audit Services - Daily revenue verification and fraud prevention controls',
        'Tax Compliance - GST/VAT reporting, payroll tax, and lodgement services',
        'Management Reporting - Executive dashboards, KPI tracking, and investor reports',
        'Financial Systems Integration - Seamless connection with PMS, POS, and other hotel systems',
        'Franchise Reporting - Monthly franchisor reports and royalty calculations',
        'Owner & Investor Reporting - Detailed monthly financial packages with commentary and analysis'
      ],
      benefits: [
        'Complete financial visibility and transparency',
        'Timely and accurate financial reporting',
        'Improved cash flow management',
        'Better cost control and margin optimization',
        'Compliance with accounting standards and regulations',
        'Strategic insights for investment decisions',
        'Reduced risk of errors and financial irregularities'
      ]
    }
  ],

  // ============================================
  // HERO SECTION CONTENT
  // ============================================
  hero: {
    title: 'We are Repose Hotels',
    subtitle: 'Strategic Hotel Asset Partners',
    description: 'Driving Hotel Performance Through Strategy, Discipline & Proven Leadership',
    cta: {
      primary: 'Partner With Us',
      secondary: 'Learn More'
    }
  }
};

export default siteConfig;
